import { toDate as f } from "./toDate.js";
import { constructFrom as s } from "./constructFrom.js";
function h(n, o) {
  const t = f(n);
  if (isNaN(o))
    return s(n, NaN);
  if (!o)
    return t;
  const r = t.getDate(), e = s(n, t.getTime());
  e.setMonth(t.getMonth() + o + 1, 0);
  const a = e.getDate();
  return r >= a ? e : (t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    r
  ), t);
}
export {
  h as addMonths,
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/addMonths.js
// module id = 235
// module chunks = 41